import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";

import { Paginator } from "primereact/paginator";
import moment from "moment";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import api from "../../services/api";
import Constants from "../../services/constants";
import { exportTableToCsv } from "../../utils/exportTableCsv";

export default function CallLogsTable({ heading, allCallLogs, loading, history, search, setSearch, page, limit, totalRecords, setPage, setLimit, callType }) {
    const [selectedRow, setSelectedRow] = useState([]);
    const [currentPage, setCurrentPage] = useState(page);
    const [pageSize, setPageSize] = useState(limit);
    const [exporting, setExporting] = useState(false);

    // const actions = (d) => {
    //     return (
    //         <div className="flex justify-content-around">
    //             <i className="pi pi-eye cursor-pointer text-dark" onClick={() => history(`/call-logs/view/${d._id}`)}></i>
    //         </div>
    //     );
    // };

    const dateFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e) => {
                    options.filterCallback(e.value, options.index);
                }}
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
                mask="99/99/9999"
            />
        );
    };

    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };

    const formatDate = (date) => {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')

        // return date?.toLocaleDateString?.("en-US", {
        //     day: "2-digit",
        //     month: "2-digit",
        //     year: "numeric",
        // });
    };

    const caller = (data) => {
        const userId = data?.caller?.userId
        const userDBId = data?.caller?._id
        const userPhone = data?.caller?.countryCode && data?.caller?.mobile
            ? `${data.caller.countryCode}${data.caller.mobile}`
            : null;

        return (
            <span style={{ cursor: 'pointer' }} className="link" onClick={() => history(`/user/view/${userDBId}`)}>
                {userId} {userPhone ? `(${userPhone})` : null}
            </span>
        ) ?? null;
    }

    const reciever = (data) => {
        const userId = data?.reciever?.userId
        const userDBId = data?.reciever?._id
        const userPhone = data?.reciever?.countryCode && data?.reciever?.mobile
            ? `${data.reciever.countryCode}${data.reciever.mobile}`
            : null;

        return (
            <span style={{ cursor: 'pointer' }} className="link" onClick={() => history(`/user/view/${userDBId}`)}>
                {userId} {userPhone ? `(${userPhone})` : null}
            </span>
        ) ?? null;
    }

    const recieverVehicle = (data) => {
        const vehicleNumber = data?.vehicle?.vehicleNumber
        return vehicleNumber || "-";

    }

    const callerText = (data) => {
        const userId = data?.caller?.userId;
        const userPhone = data?.caller?.countryCode && data?.caller?.mobile
            ? `${data.caller.countryCode}${data.caller.mobile}`
            : null;
        return [userId, userPhone ? `(${userPhone})` : null].filter(Boolean).join(" ") || "-";
    };

    const recieverText = (data) => {
        const userId = data?.reciever?.userId;
        const userPhone = data?.reciever?.countryCode && data?.reciever?.mobile
            ? `${data.reciever.countryCode}${data.reciever.mobile}`
            : null;
        return [userId, userPhone ? `(${userPhone})` : null].filter(Boolean).join(" ") || "-";
    };

    // One-off fetch bypassing the redux action on purpose: getCallLogs dispatches
    // into the same slice this table's visible page reads from, so reusing it
    // here would overwrite the on-screen pagination. This fetches everything
    // matching the current search (and call type) directly for export only.
    const exportAll = async () => {
        setExporting(true);
        try {
            let url = `${Constants.END_POINT.CALL_LOGS}?page=1&limit=10000&search=${encodeURIComponent(search || "")}`;
            if (callType) {
                url += `&callType=${callType}`;
            }
            const res = await api("get", url);
            const rows = (res?.data?.data || []).map((item) => ({ ...item, time: new Date(item.time) }));
            exportTableToCsv("call-logs.csv", rows, [
                { header: "Caller", value: callerText },
                { header: "Reciever", value: recieverText },
                { header: "Reciever's Vehicle Number", value: recieverVehicle },
                { header: "Call Status", value: (row) => getSeverity(row.status).value || row.status },
                { header: "Call Duration", value: callDuration },
                { header: "Date and Time", value: (row) => formatDate(row.time) },
            ]);
        } finally {
            setExporting(false);
        }
    };

    // Function to handle pagination change
    const onPageChange = (event) => {
        setCurrentPage(event.first / event.rows + 1);
        setPage(event.page + 1)
        setLimit(event.rows)
        setPageSize(event.rows);
    };

    const getSeverity = (status) => {
        switch (status) {
            case 'COMPLETED':
                return { rowSeverity: 'success', value: 'Completed' };
            case 'ANSWERED':
                return { rowSeverity: 'success', value: 'Answered' };
            case 'NOTANSWERED':
                return { rowSeverity: 'info', value: 'Not Answered' };
            case 'ACTIVE':
                return { rowSeverity: 'warning', value: 'Active' };
            case 'REJECTED':
                return { rowSeverity: 'danger', value: 'Rejected' };
            case 'MASKED':
                return { rowSeverity: 'success', value: 'Masked' };
            case 'FREE':
                return { rowSeverity: 'info', value: 'Free' };
            default:
                return { rowSeverity: null, value: null };
        }
    };

    const callStatusTemplate = (rowData) => {
        const { rowSeverity, value } = getSeverity(rowData.status)
        return <Tag value={value} severity={rowSeverity} />;
    };


    const callTypeTemplate = (rowData) => {
        const { rowSeverity, value } = getSeverity(rowData?.callType)
        return (
            <Tag value={value} severity={rowSeverity} />
        );
    };

    const callDuration = (rowData) => {
        const duration = rowData?.callDuration;

        if (!duration && duration !== 0) return "-";

        if (duration < 60) {
            return `${duration}s`;
        }

        const minutes = Math.floor(duration / 60);
        const seconds = duration % 60;

        if (seconds === 0) {
            return `${minutes}m`;
        }

        return `${minutes}m ${seconds}s`;
    };

    return (
        <>
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-between mb-4">
                        <h5>{heading}</h5>
                        <div className="flex align-items-center">
                            {setSearch ? (
                                <div className="p-input-icon-left mx-2">
                                    <i className="pi pi-search" />
                                    <InputText value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" />
                                </div>
                            ) : null}
                            <Button
                                label="Export CSV"
                                icon="pi pi-download"
                                onClick={exportAll}
                                loading={exporting}
                                disabled={!totalRecords}
                                severity="success"
                            />
                        </div>
                    </div>
                    <DataTable
                        // paginator
                        value={allCallLogs}
                        filter={filters}
                        filterDisplay="menu"
                        loading={loading}
                        emptyMessage="No Call Logs found."
                        className=""
                        showGridlines
                        first={(currentPage - 1) * pageSize}
                        rows={pageSize}
                        totalRecords={totalRecords || 0}
                        onPage={onPageChange}
                    >
                        <Column body={caller} header="Caller"></Column>
                        <Column body={reciever} header="Reciever"></Column>
                        <Column body={recieverVehicle} header="Reciever's Vehicle Number"></Column>
                        {/* <Column body={callTypeTemplate} header="Call Type"></Column>       */}
                        <Column body={callStatusTemplate} header="Call Status"></Column>
                        <Column body={callDuration} header="Call Duration"></Column>
                        <Column
                            header="Date and Time"
                            field="time"
                            dataType="date"
                            // style={{ width: "150px" }}
                            filterMatchMode="dateIs"
                            showFilterMatchModes={true}
                            body={(rowData) => formatDate(rowData.time)}
                            filter
                            filterElement={dateFilterTemplate}
                        />
                        {/* <Column body={actions} style={{ width: "80px" }} header="Action"></Column> */}
                    </DataTable>
                    <Paginator
                        first={(currentPage - 1) * pageSize}
                        rows={pageSize}
                        totalRecords={totalRecords || 0}
                        onPageChange={onPageChange}
                        rowsPerPageOptions={[10, 20, 30]}
                    />
                </div>
            </div>
        </>
    );
}
